var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlanket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 384H88C83.578 384 80 387.578 80 392S83.578 400 88 400H400C426.469 400 448 378.469 448 352V104C448 64.297 415.703 32 376 32H72C32.297 32 0 64.297 0 104C0 104 0 389.799 0 392C0 440.531 39.469 480 88 480H440C444.422 480 448 476.422 448 472S444.422 464 440 464H88C48.297 464 16 431.703 16 392S48.297 320 88 320H400C417.641 320 432 334.359 432 352S417.641 384 400 384ZM400 304H88C58.205 304 31.928 318.957 16 341.674V104C16 73.125 41.125 48 72 48H376C406.875 48 432 73.125 432 104V316.484C423.488 308.809 412.338 304 400 304Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlanket);
export default __webpack_public_path__ + "static/media/blanket.38e5664542483ab6bc9ad3e426ed9960.svg";
export { ForwardRef as ReactComponent };